import React from "react";
import { Input } from "./Input";

/**
 * Native date picker (uses `<input type="date">`). Design-system-wrapped for
 * consistent field spacing and label style.
 */
export function DatePicker(props) {
  return <Input type="date" {...props} />;
}
